import React, { useState } from 'react';

import tobeor from 'tobeor';

import * as DOMPurify from 'dompurify';

import { ButtonBase} from '@mui/material';

import AccountTreeIcon from '@mui/icons-material/AccountTree';
import WidgetCheckboxes from './TrplFormRowComponents/WidgetCheckboxes';
import WidgetHTMLTextEditor from './TrplFormRowComponents/WidgetHtml/WidgetHTMLTextEditor';

import TrplTextfield from '../TrplControls/TrplTextfield';
import InfoAlert from './TrplFormRowComponents/InfoAlert';

import MapTrpl from './TrplFormRowComponents/MapTrpl';
import UrlTrpls from './TrplFormRowComponents/UrlTrpls';
import FilesTrpl from './TrplFormRowComponents/FilesTrpl';
import TextTrpls from './TrplFormRowComponents/TextTrpls';
import ButtonTrpl from './TrplFormRowComponents/ButtonTrpl';
import NodePicker from './TrplFormRowComponents/NodePicker';
import SelectTrpls from './TrplFormRowComponents/SelectTrpls';
import TimeControl from './TrplFormRowComponents/TimeControl';
import CheckboxTrpl from './TrplFormRowComponents/CheckboxTrpl';
import SetDeleteTrplBtns from './TrplFormRowComponents/SetDeleteTrplBtns';

const addPlaceholderTrplInEndIfNeeded = (trplArray, isPossibleAddNewTrpl) => {
  const updatedTrplsArray = trplArray ? [...trplArray] : [];

  const [lastTrpl] = updatedTrplsArray.slice(-1);
  const lastExistOnBackend = lastTrpl && lastTrpl.tid;

  const placeholderTrpl = { val: '' };

  isPossibleAddNewTrpl && (!lastTrpl || lastExistOnBackend) && updatedTrplsArray.push(placeholderTrpl);

  return updatedTrplsArray;
};

const updateTrplAncestor = (getTrplNode, rst, ancestorId) => {
  if (rst && rst.id && getTrplNode) {
    const trplsNode = (Array.isArray(rst.id) && rst.id.length > 1) ? getTrplNode(rst.id, 0, ancestorId) : ancestorId;
    return trplsNode;
  } else return ancestorId;
};

export default ({
    rst,
    data,
    item,
    formId,
    setTrpl,
    classes,
    isGroup,
    groupId,
    rstData,
    isNewNode,
    ancestorId,
    getTrplNode,
    saveOnlyForm,
    isAnotherNode,
    submitOnlyForm,
    onRstValueEdit,
    removeTrplValue,
    onRstTypeBtnClick,
    onNodeRemoveClick,
    openObjectEditModal,
    toggleUploadImgModal,
    isDisableTrplEditing,
    getAutocompleteTrpls,
    showEmptyValOnBounds,
    onChangeTextereaHeight,
    updateDataOnRestoreTrpl,
    openTrplRenderPartsModal,
    onWidgetCheckboxesValueEdit,
    onNodeAddDropdownElementClick,
  }) => {

  if (!rstData) return null;

  const [loadingTids, setNewLoadingTids] = useState([]);
  const [deletedTids, setNewDeletedTids] = useState([]);
    
  const { type, isVirtual, trplArray, isPossibleAddNewTrpl, tidsChains, mode } = rstData;

  const setLoadingTids = (isLoading, tid) => {
    const newLoadingTids = [...loadingTids];

    if (isLoading) {
      newLoadingTids.push(tid);
    } else {
      const delTidIndex = newLoadingTids.indexOf(tid);
      if (delTidIndex > -1) {
        newLoadingTids.splice(delTidIndex, 1);
      }
    }

    setNewLoadingTids(newLoadingTids);
  };

  const setDeletedTrplId = (value) => {
    setNewDeletedTids([ value, ...deletedTids ]);
  };

  const resetDeletedTrplId = (value) => {
    if (deletedTids.length) {
      const rstId = +Object.keys(value)[0];
      const tid = +Object.values(value)[0];
      const newDeletedTids = [ ...deletedTids ];

      const deletedTidIndex = newDeletedTids.find((deleted, index) => {
        if (+(Object.keys(deleted)[0] === rstId) && (+Object.values(deleted)[0] === tid)) return index;
      });
      if (deletedTidIndex !== -1) newDeletedTids.splice(deletedTidIndex, 1);

      setNewDeletedTids(newDeletedTids);
    }
  };
    
  // TODO move to constants
  const renderPartsTrpl = type === 'render_parts'
    && data.trpls[ancestorId] && data.trpls[ancestorId][rst.id] && data.trpls[ancestorId][rst.id][0];

  const showMandatoryAlert = trplArray.length < rst.subjectMinBound ||
    (item && ((item.required === true) || (item.required === 'true')));

  const trpls = addPlaceholderTrplInEndIfNeeded(trplArray, isPossibleAddNewTrpl);

  const trplsNode = isGroup ? updateTrplAncestor(getTrplNode, rst, ancestorId) : ancestorId;

  let lastTriple = trpls[trpls.length - 1];

  let editable = true;
  if (item) {
    if (item.editable === undefined) item.editable = true;
    if (item.editable === false || item.editable === true) editable = item.editable;
  }

  let hasTripleWarning = false;
  trpls.forEach(triple => {
    if (triple.warnings) hasTripleWarning = true;
  });

  const disabledDefaultField = rst.has_def_val && (lastTriple && !lastTriple.tid) && isNewNode;

  let constant = false;
  if ((lastTriple && !lastTriple.tid) || hasTripleWarning) constant = false;
  else if (rst.isConstant) constant = true;
  if (isVirtual && rst.isConstant) constant = true; // virtual is non-editable, but other editable if no value
  
  // const enabledDefaultField = rst.has_def_val && (lastTriple && !lastTriple.tid) && isNewNode;
  // const disabledDefaultField = enabledDefaultField && rst.isConstant;

  let itemTitle = item && item.title ? item.title : rst.title;

  if (item && item.trpl_filters && !rst.trpl_filters) rst.trpl_filters = item.trpl_filters;
  if (item && item.render_widget) rst.render_widget = item.render_widget;

  let disableTrplEditing = !editable || (isDisableTrplEditing && isDisableTrplEditing(ancestorId, rst.id)) || mode === 'READ';
  const hideSetDelete = submitOnlyForm || saveOnlyForm;

  return (
    <React.Fragment key={rst.id}>
      {type === 'render_parts' ? (
        <div key={`${itemTitle} ${rst.id}`} className={classes.rstRenderPartTrplContainer}>
          <div className={classes.alignCenter}>
            <ButtonBase
              size="small"
              disabled={isNewNode}
              className={`${classes.btn} ${classes.btnNormal} ${classes.btnRenderParts}`}
              onClick={(e) => openTrplRenderPartsModal(rst, data)}
              style={{
                textTransform: 'capitalize',
                borderRadius: '10px',
              }}
            >
              Edit <AccountTreeIcon style={{ fontSize: '12px', marginLeft: '4px' }} />
            </ButtonBase>

            <span style={{ marginLeft: '10px', fontSize: '12px' }}>{renderPartsTrpl && renderPartsTrpl.val}</span>
          </div>

          {renderPartsTrpl && renderPartsTrpl.tid &&
            <SetDeleteTrplBtns
              rst={rst}
              type={type}
              trpl={renderPartsTrpl}
              groupId={groupId}
              classes={classes}
              setTrpl={setTrpl}
              ancestorId={trplsNode}
              loadingTids={loadingTids}
              isAnotherNode={isAnotherNode}
              removeTrplValue={removeTrplValue}
              setLoadingTids={setLoadingTids}
            />
          }
        </div>
      ) : disabledDefaultField ? (
        <div className={`${classes.alignCenter}`}>
          <TrplTextfield
            disabled={true}
            fullWidth
            margin="none"
            InputProps={{
              classes: {
                root: classes.trplTextField,
                input: classes.trplIsDefault,
              },
            }}
            rows={1}
            type={'text'}
            value={' '}
          />
          <div style={{ marginRight: hideSetDelete ? '' : '30px' }}>
            <InfoAlert />
          </div>
        </div>
        ) : rst.render_widget === 'html_text_editor' ? (
          trpls.map((trpl, index) => {
            return (
              <WidgetHTMLTextEditor
                rst={rst}
                data={data}
                type={type}
                trpl={trpl}
                groupId={groupId}
                setTrpl={setTrpl}
                classes={classes}
                trplIndex={index}
                constant={constant}
                isNewNode={isNewNode}
                isVirtual={isVirtual}
                ancestorId={trplsNode}
                tidsChains={tidsChains}
                loadingTids={loadingTids}
                deletedTids={deletedTids}
                hideSetDelete={hideSetDelete}
                isAnotherNode={isAnotherNode}
                onRstValueEdit={onRstValueEdit}
                setLoadingTids={setLoadingTids}
                removeTrplValue={removeTrplValue}
                showMandatoryAlert={showMandatoryAlert}
                disableTrplEditing={disableTrplEditing}
                setDeletedTrplId={setDeletedTrplId}
                resetDeletedTrplId={resetDeletedTrplId}
                updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
              />)
            })
      ) : rst.render_widget === 'multi_prdc_checkboxes' ? (
        <WidgetCheckboxes
          rst={rst}
          data={data}
          trpls={trpls}
          classes={classes}
          constant={constant}
          ancestorId={trplsNode}
          showMandatoryAlert={showMandatoryAlert}
          disableTrplEditing={disableTrplEditing}
          onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
        />
      ) : rst.render_widget === 'html' ? (
        trpls.map((trpl, index) => {
          const clean = DOMPurify.sanitize(trpl.val, { USE_PROFILES: { html: true } });

          const htmlTrplClasses = `${isVirtual
            ? classes.notEditableVirtualTrpl
            : trpl && trpl.tid
                ? classes.notEditableTrplWithValue
                : classes.trplEmpty
          }`;
          return (
            <div
              key={index}
              className={htmlTrplClasses}
              style={{
                color: '#4c4c4c',
                padding: '3px 5px',
                contain: 'inline-size',
              }}
            >
              {/<\/?[a-z][\s\S]*>/i.test(clean) ?
                <div
                  className={classes.fillAvailable}
                  style={{ border: 'none', overflow: 'auto', margin: '0px' }}
                  dangerouslySetInnerHTML={{ __html: clean }}
                />
                // <iframe
                //   srcDoc={clean}
                //   className={classes.fillAvailable}
                //   style={{ border: 'none', overflow: 'auto', margin: '0px' }}
                // />
              :
                <pre style={{ overflow: 'auto', textWrap: 'auto', margin: '0px', fontSize: 12, lineHeight: 'normal' }}>{clean}</pre>
              }
          </div>
          )
        })
      ) : type === 'location' ? (
        <MapTrpl
          rst={rst}
          type={type}
          trpls={trpls}
          groupId={groupId}
          classes={classes}
          setTrpl={setTrpl}
          constant={constant}
          ancestorId={trplsNode}
          loadingTids={loadingTids}
          deletedTids={deletedTids}
          hideSetDelete={hideSetDelete}
          isAnotherNode={isAnotherNode}
          setLoadingTids={setLoadingTids}
          removeTrplValue={removeTrplValue}
          disableTrplEditing={disableTrplEditing}
          setDeletedTrplId={setDeletedTrplId}
          resetDeletedTrplId={resetDeletedTrplId}
          updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
        />
      ) : type === 'file' ? (
        <FilesTrpl
          rst={rst}
          trpls={trpls}
          type={type}
          classes={classes}
          groupId={groupId}
          setTrpl={setTrpl}
          constant={constant}
          ancestorId={trplsNode}
          loadingTids={loadingTids}
          isAnotherNode={isAnotherNode}
          removeTrplValue={removeTrplValue}
          setLoadingTids={setLoadingTids}
          disableTrplEditing={disableTrplEditing}
          showMandatoryAlert={showMandatoryAlert}
          toggleUploadImgModal={toggleUploadImgModal}
        />
      ) : type === 'button' ? (
        <ButtonTrpl
          rst={rst}
          trpls={trpls}
          groupId={groupId}
          classes={classes}
          constant={constant}
          isNewNode={isNewNode}
          ancestorId={trplsNode}
          loadingTids={loadingTids}
          isAnotherNode={isAnotherNode}
          setLoadingTids={setLoadingTids}
          onRstTypeBtnClick={onRstTypeBtnClick}
          disableTrplEditing={disableTrplEditing}
        />
      ) : tobeor(type, ['datetime', 'date', 'time']) ? (
        <TimeControl
          rst={rst}
          trpls={trpls}
          type={type}
          groupId={groupId}
          classes={classes}
          setTrpl={setTrpl}
          constant={constant}
          isVirtual={isVirtual}
          isNewNode={isNewNode}
          ancestorId={trplsNode}
          tidsChains={tidsChains}
          loadingTids={loadingTids}
          deletedTids={deletedTids}
          hideSetDelete={hideSetDelete}
          isAnotherNode={isAnotherNode}
          setLoadingTids={setLoadingTids}
          onRstValueEdit={onRstValueEdit}
          removeTrplValue={removeTrplValue}
          showMandatoryAlert={showMandatoryAlert}
          disableTrplEditing={disableTrplEditing}
          setDeletedTrplId={setDeletedTrplId}
          resetDeletedTrplId= {resetDeletedTrplId}
          updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
        />
      ) : type === 'checkbox' ? (
        <CheckboxTrpl
          rst={rst}
          trpls={trpls}
          type={type}
          groupId={groupId}
          classes={classes}
          setTrpl={setTrpl}
          constant={constant}
          isNewNode={isNewNode}
          isVirtual={isVirtual}
          ancestorId={trplsNode}
          tidsChains={tidsChains}
          loadingTids={loadingTids}
          isAnotherNode={isAnotherNode}
          hideSetDelete={hideSetDelete}
          setLoadingTids={setLoadingTids}
          onRstValueEdit={onRstValueEdit}
          removeTrplValue={removeTrplValue}
          disableTrplEditing={disableTrplEditing}
          showMandatoryAlert={showMandatoryAlert}
        />
      ) : type === 'select' ? (
        <SelectTrpls
          rst={rst}
          trpls={trpls}
          type={type}
          groupId={groupId}
          classes={classes}
          setTrpl={setTrpl}
          constant={constant}
          isVirtual={isVirtual}
          isNewNode={isNewNode}
          ancestorId={trplsNode}
          tidsChains={tidsChains}
          loadingTids={loadingTids}
          deletedTids={deletedTids}
          hideSetDelete={hideSetDelete}
          isAnotherNode={isAnotherNode}
          setLoadingTids={setLoadingTids}
          onRstValueEdit={onRstValueEdit}
          removeTrplValue={removeTrplValue}
          disableTrplEditing={disableTrplEditing}
          showMandatoryAlert={showMandatoryAlert}
          setDeletedTrplId={setDeletedTrplId}
          resetDeletedTrplId= {resetDeletedTrplId}
          showEmptyValOnBounds={showEmptyValOnBounds}
          updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
        />
      ) : type === 'node' ? (
        <NodePicker
          rst={rst}
          data={data}
          trpls={trpls}
          groupId={groupId}
          classes={classes}
          constant={constant}
          ancestorId={trplsNode}
          loadingTids={loadingTids}
          isAnotherNode={isAnotherNode}
          setLoadingTids={setLoadingTids}
          onNodeRemoveClick={onNodeRemoveClick}
          disableTrplEditing={disableTrplEditing}
          showMandatoryAlert={showMandatoryAlert}
          openObjectEditModal={openObjectEditModal}
          disableNodeEditFormOpening={mode === 'NONE'}
          onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
        />
      ) : type === 'url' ? (
        <UrlTrpls
          rst={rst}
          trpls={trpls}
          type={type}
          groupId={groupId}
          classes={classes}
          setTrpl={setTrpl}
          constant={constant}
          isVirtual={isVirtual}
          isNewNode={isNewNode}
          ancestorId={trplsNode}
          loadingTids={loadingTids}
          deletedTids={deletedTids}
          hideSetDelete={hideSetDelete}
          isAnotherNode={isAnotherNode}
          setLoadingTids={setLoadingTids}
          onRstValueEdit={onRstValueEdit}
          removeTrplValue={removeTrplValue}
          showMandatoryAlert={showMandatoryAlert}
          disableTrplEditing={disableTrplEditing}
          setDeletedTrplId={setDeletedTrplId}
          resetDeletedTrplId= {resetDeletedTrplId}
          updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
        />            
      ) : (
        <TextTrpls
          rst={rst}
          item={item}
          trpls={trpls}
          type={type}
          formId={formId}
          classes={classes}
          groupId={groupId}
          setTrpl={setTrpl}
          constant={constant}
          isVirtual={isVirtual}
          isNewNode={isNewNode}
          ancestorId={trplsNode}
          tidsChains={tidsChains}
          loadingTids={loadingTids}
          deletedTids={deletedTids}
          hideSetDelete={hideSetDelete}
          isAnotherNode={isAnotherNode}
          setLoadingTids={setLoadingTids}
          onRstValueEdit={onRstValueEdit}
          removeTrplValue={removeTrplValue}
          disableTrplEditing={disableTrplEditing}
          showMandatoryAlert={showMandatoryAlert}
          setDeletedTrplId={setDeletedTrplId}
          getAutocompleteTrpls={getAutocompleteTrpls}
          resetDeletedTrplId= {resetDeletedTrplId}
          onChangeTextereaHeight={onChangeTextereaHeight}
          updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
        />
      )}
    </React.Fragment>
    )
  }
;
